import { css } from "@emotion/react";
import { NEW_VERSION_MSG } from "@app/constants";
import { Trans } from "@lingui/macro";

const rootStyle = theme => css`
  display: flex;
  align-items: center;
  gap: 12px;
  span {
    cursor: pointer;
    color: inherit;
    font-weight: ${theme.typography.subtitle2.fontWeight};
    margin-left: 8px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const NewVersionToast = () => <div css={rootStyle}>{NEW_VERSION_MSG}<span onClick={() => window.location.reload()}><Trans>Reload</Trans></span></div>;

export default NewVersionToast;
